// normalize list to avoid duplicates and keep stable order
function normalizeList(values: readonly (string | number | boolean)[]) {
  return Array.from(new Set(values.map(String))).sort(); // without duplicates + stable order
}

/**
 * If the list changes, returns a new URLSearchParams; if not, returns null.
 * - Deletes the key if nextValues is empty (deleteIfEmpty=true).
 * - Does nothing if the resulting state would be identical to the current one.
 */
export function setQueryParamList(
  current: URLSearchParams,
  key: string,
  nextValues: readonly (string | number | boolean)[],
  { deleteIfEmpty = true }: { deleteIfEmpty?: boolean } = {}
): URLSearchParams | null {
  const prev = normalizeList(current.getAll(key));
  const next = normalizeList(nextValues);

  // no real changes?
  if (prev.length === next.length && prev.every((v, i) => v === next[i])) {
    return null;
  }

  const updated = new URLSearchParams(current);

  if (deleteIfEmpty && next.length === 0) {
    // if it didn't exist, no generate update
    if (!current.has(key)) return null;
    updated.delete(key);
    return updated.toString() !== current.toString() ? updated : null;
  }

  // Replace the list completely (without duplicates)
  updated.delete(key);
  // Keep the order received if you want (no affects the comparison)
  Array.from(new Set(nextValues.map(String))).forEach(v =>
    updated.append(key, v)
  );

  return updated.toString() !== current.toString() ? updated : null;
}
